"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ContextMenu = _interopRequireDefault(require("../ContextMenu"));

var _TitleAuthor = _interopRequireDefault(require("./TitleInfo/TitleAuthor"));

var _TitleEdition = _interopRequireDefault(require("./TitleInfo/TitleEdition"));

var _TitleName = _interopRequireDefault(require("./TitleInfo/TitleName"));

var _TitleFormatBadge = _interopRequireDefault(require("./TitleInfo/TitleFormatBadge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TitleInfo =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(TitleInfo, _Backbone$View);

  _createClass(TitleInfo, [{
    key: "className",
    get: function get() {
      return 'title-info';
    }
  }]);

  function TitleInfo() {
    var _this;

    _classCallCheck(this, TitleInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitleInfo).apply(this, arguments));
    _this._views = [];

    _this.render();

    return _this;
  }

  _createClass(TitleInfo, [{
    key: "_reset",
    value: function _reset() {
      this._views.forEach(function (view) {
        return view.remove();
      });

      this._views = [];
    }
  }, {
    key: "remove",
    value: function remove() {
      this._reset();

      _get(_getPrototypeOf(TitleInfo.prototype), "remove", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      this._reset();

      this._views.push(this.contextMenu = new _ContextMenu["default"]({
        model: this.model
      }));

      if (this.model.isMagazine) {
        this._views.push(this.titleEdition = new _TitleEdition["default"]({
          model: this.model
        }));
      } else {
        this._views.push(this.titleAuthor = new _TitleAuthor["default"]({
          model: this.model
        }));
      }

      this._views.push(this.titleName = new _TitleName["default"]({
        model: this.model
      }));

      this._views.push(this.titleFormatBadge = new _TitleFormatBadge["default"]({
        typeId: this.model.get('type').id
      }));

      this.$el.empty();
      this.$el.append(this.titleName.$el, this.contextMenu.$el.addClass('text-right'), this.model.isMagazine ? this.titleEdition.$el : this.titleAuthor.$el, this.titleFormatBadge.$el);
    }
  }]);

  return TitleInfo;
}(Backbone.View);

exports["default"] = TitleInfo;